import type { Theme } from '@emotion/react';

export enum EMPTY_STATE_ACHIEVEMENT_VARIANTS {
  YELLOW = 'YELLOW',
  GRAY = 'GRAY',
}

export const getEmptyStateAchievementFills = (
  theme: Theme,
  type: EMPTY_STATE_ACHIEVEMENT_VARIANTS,
) => {
  switch (type) {
    case EMPTY_STATE_ACHIEVEMENT_VARIANTS.YELLOW:
    default:
      return {
        fill: theme.hues.yellow[50],
        stroke: theme.hues.yellow[200],
      };
    case EMPTY_STATE_ACHIEVEMENT_VARIANTS.GRAY:
      return {
        fill: theme.hues.gray[50],
        stroke: theme.hues.gray[300],
      };
  }
};
